import { Inject, Injectable } from '@angular/core';
import { FacebookPixelConfiguration } from '../facebook-pixel.module';

declare const fbq: any;

@Injectable({
  providedIn: 'root',
})
export class FacebookPixelService {
  private initialized = false;

  constructor(@Inject('facebookPixelConfig') private config: FacebookPixelConfiguration) {}

  initialize() {
    if (!this.config.enabled || this.initialized) {
      return;
    }

    const script = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${this.config.facebookPixelId}');
      fbq('track', 'PageView');
    `;

    const scriptElement = document.createElement('script');
    scriptElement.textContent = script;

    document.head.appendChild(scriptElement);

    this.initialized = true;
  }

  trackCustom(eventName: string) {
    fbq('trackCustom', eventName);
  }
}
